import {CloseOutlined} from '@ant-design/icons';
import {Button, Col, Descriptions, Divider, Flex, Input, Popconfirm, Row, Select, Space} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {deleteBranchIssueAPI, deleteBranchStaffAPI, deleteBranchStaffJobAPI, getBranchAPI, getBranchIssueAPI, getBranchJobStaffListAPI, getBranchStaffJobListAPI, getBranchStaffListAPI, postBranchIssueAPI, postBranchStaffAPI, postBranchStaffJobAPI, putBranchIssueAPI, putBranchStaffAPI} from 'api/branch';
import {getListAPI} from 'api/common';
import {IconDownloadExcel, IconExclamation} from 'components/assets/icons';
import {AlertModal, BaseContainer, SearchDesc, SimpleModal} from 'components/containers';
import {BaseButton, BaseDatePicker, DataGrid, FillButton, OutlinedButton, RoundTag, ExcelButton} from 'components/elements';
import {BaseSection} from 'components/layouts';
import {bankCodeOptions, completionStatusOption, searchTypeOptions, staffEmployTypeOption} from 'data/options';
import dayjs from 'dayjs';
import {useAuth} from 'hooks/AuthContext';
import {getLocalStorage} from 'hooks/useLocalStorage';
import {GridSetting} from 'pages/common';
import SchoolManageEdit from 'pages/hq/school/manage/tabs/SchoolManageEdit';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {URL_ADMIN, URL_ADMIN_BRANCH, URL_ADMIN_BRANCH_MANAGE_ADD, URL_ADMIN_BRANCH_MANAGE_DETAIL, URL_ADMIN_BRANCH_MANAGE_EDIT} from 'routes/AdminRoute';
import {exportStyleExcelDownload} from 'utils/file';
import {fnCellPhoneFormat, fnSetColumn, getFormatDate, objToLowerCase, utilSearchData} from 'utils/utils';

function BranchManage() {
  const navigate = useNavigate();
  const menu = getLocalStorage('openMenuInfo');
  const [excelHeaders, setExcelHeaders] = useState([])
  const [colList, setColList] = useState({
    gridSettingList: [],
    gridList: []
  });
  const [branch, setBranch] = useState({});
  const [branchList, setBranchList] = useState([]);
  const [employee, setEmployee] = useState({origin: [{}, {}], current: [{}, {}]});
  const [issue, setIssue] = useState([]);
  const [staffJob, setStaffJob] = useState([]);
  const [option, setOption] = useState({});
  const [modal, setModal] = useState({isEmpOpen: false, isBranchIssue: false, staffJobDivision: false, isDetail: false});
  const [columns, setColumns] = useState([]);
  const [search, setSearch] = useState({
    search_state: 'branch_name',
    search_content: ''
  });
  const [gridSetting, setGridSetting] = useState([]);
  const [focusLow, setFocusLow] = useState(-1);
  const {user} = useAuth();
  const [alertModal, setAlertModal] = useState({
    open: false,
    message: ''
  });

  const fnCloseAlertModal = () => {
    setAlertModal({...alertModal, open: false, message: ''});
  };

  const popupClose = (index) => {
    const elem = document.querySelector(`.custom-cancel-className-${index}`);
    elem.click();
  };

  const fnExcelDownload = () => {
    const processData = branchList?.map((item) => {
      const obj = {}
      colList?.gridList.forEach(it => {
        obj[it.dataIndex] = item[it.dataIndex]
      });
      return obj
    });

    const headerList = colList?.gridList.map(it => it.title)
    exportStyleExcelDownload(headerList, processData, menu?.depth?.[1]);
  };

  const getBranchIssue = async (params) => {
    try {
      await getBranchIssueAPI(params).then((res) => {
        if (res.status === 200) {
          setIssue(res.data.data_list);
        }
      });
    } catch (err) {
      console.error(err)
    }
  };

  const getBranchIssueModal = (idx) => {
    getBranchIssue(idx);
    setBranch({branch_idx: idx});
    setModal({
      ...modal,
      isBranchIssue: true,
      isEmpOpen: false,
      staffJobDivision: false,
      isDetail: false
    });
  };

  const postBranchIssue = async () => {
    let params = {};
    await getBranchAPI(branch?.branch_idx)
      .then((res) => {
        const data = res.data.data_info;
        params = {
          BRANCH_ID: data.BRANCH_ID,
          BRANCH_NAME: data.BRANCH_NAME,
          BRANCH_LEADER_NAME: data.BRANCH_LEADER_NAME,
          WRITER: user.user_name,
          ISSUE: ''
        };
        setIssue([...issue, {key: issue.length, ...params}]);
      })
      .catch((err) => {
      });
  };

  const fnAddIssue = async (record) => {
    await postBranchIssueAPI({...objToLowerCase(record), idx: branch?.branch_idx})
      .then((res) => {
        const {responseCode} = res.data;
        if (responseCode === 200) {
          alert('등록되었습니다.');
          getBranchIssue(branch?.branch_idx);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally();
  };

  // 지사 이슈 수정
  const fnUpdateIssue = async (record) => {
    await putBranchIssueAPI(record.IDX, {issue: record.ISSUE}).then((res) => {
      if (res.data.responseCode === 200) {
        alert('수정되었습니다.');
        setIssue('');
        getBranchIssue(branch?.branch_idx);
      }
    }).catch(err => console.error(err));
  };

  // 지사 이슈 삭제
  const fnDeleteIssue = async (idx) => {
    await deleteBranchIssueAPI(idx).then((res) => {
      if (res.data.responseCode === 200) {
        alert('삭제되었습니다.');
        setIssue('');
        getBranchIssue(branch?.branch_idx);
      }
    });
  };

  const fnSetData = (e, index, key) => {
    const obj = {};
    obj[key] = e;
    employee.current[index] = {...employee.current[index], ...obj};
    setEmployee({...employee, current: [...employee.current]});
  };

  const fnSetIssueData = (e, record, index, key) => {
    const obj = {};
    obj[key] = e.target.value;
    issue[index] = {...issue[index], ...obj};
    setIssue([...issue]);
  };

  const fnUpdateBranchStaff = async (record) => {
    await putBranchStaffAPI({branch_staff_idx: record.IDX, ...objToLowerCase(record)})
      .then((res) => {
        if (res.data.responseCode === 200) {
          alert('수정되었습니다.');
          fnBranchStaffList(record.BRANCH_IDX);
        }
      })
      .catch((err) => console.log(err));
  };

  const fnDeleteBranchStaff = async (record) => {
    const param = {branch_staff_idx: record.IDX, branch_idx: record.BRANCH_IDX};
    await deleteBranchStaffAPI(param)
      .then((res) => {
        console.log(res);
        if (res?.status === 200) {
          alert('삭제되었습니다.');
          setModal({
            ...modal,
            isBranchIssue: false,
            isEmpOpen: false,
            staffJobDivision: false,
            isDetail: false
          });
          fnGetList();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fnAddBranchStaff = async (record, index) => {
    const obj = {...employee.current[index], BRANCH_IDX: branch?.branch_idx};
    await postBranchStaffAPI({...objToLowerCase(obj), idx: branch?.branch_idx})
      .then((res) => {
        const {responseCode} = res.data;
        if (responseCode === 200) {
          alert('등록되었습니다.');
          setModal({
            ...modal,
            isBranchIssue: false,
            isEmpOpen: false,
            staffJobDivision: false,
            isDetail: false
          });
          fnGetList();
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally();
  };

  const fnGetList = async () => {
    try {
      // 공통 서치바 데이터 체크 및 데이터 리턴
      const result = utilSearchData(search);
      if (typeof result === 'string') {
        setAlertModal({...alertModal, open: true, message: result});
      } else {
        const {data} = await getListAPI(result);
        setExcelHeaders(fnSetColumn(data.COLUMS_LIST, column))
        setColList({
          ...colList,
          gridSettingList: data?.COLUMS_LIST,
          gridList: fnSetColumn(data?.COLUMS_LIST, column)
        });
        const withNum = data?.DATA_LIST?.reverse()?.map((item, index) => ({
          ...item,
          NUM: index + 1
        }))
        setBranchList(withNum);
        setColumns(fnSetColumn(data?.COLUMS_LIST, column));
        setGridSetting(data?.COLUMS_LIST);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fnGetList();
  }, []);

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
      }, // click row
      onDoubleClick: (event) => {
      }, // double click row
      onContextMenu: (event) => {
      }, // right button click row
      onMouseEnter: (event) => {
      }, // mouse enter row
      onMouseLeave: (event) => {
      } // mouse leave row
    };
  };

  const getBranchPop = (record) => {
    //지사정보
    const items = [
      {
        key: '1',
        label: '회원구분',
        children: '지사회원'
      },
      {
        key: 'ADDR',
        label: '주소',
        children: (
          <Space direction="vertical" size={0}>
            <div>({record?.ZIP_CODE})</div>
            <div>
              {record?.ADDR} {record?.ADDR_DETAIL}
            </div>
          </Space>
        )
      },
      {
        key: '3',
        label: '연락처',
        children: (
          <Space>
            <div>{record?.HOME_PHONE || '-'}</div>
            /
            <div>{record?.CELL_PHONE || '-'}</div>
          </Space>
        )
      },
      {
        key: '4',
        label: '통장정보',
        children: (
          <Space>
            <div>{bankCodeOptions.find((it) => it.value === record?.ACCOUNT_BANK)?.label || '-'} </div>
            /
            <div>{record?.ACCOUNT_INFO || '-'}</div>
          </Space>
        )
      }
    ];
    return items;
  };

  const column = [
    {
      title: '번호',
      align: 'center',
      dataIndex: 'IDX',
      render: (value, record, index) => {
        return record?.NUM
      }
    },
    {
      title: '지사명',
      align: 'center',
      dataIndex: 'BRANCH_NAME',
      width: '15rem',
      render: (value, record, index) => {
        return (
          <Flex justify="center" align="center">
            <span className="text-link" style={{whiteSpace: 'nowrap'}} onClick={() => navigate(`${URL_ADMIN + URL_ADMIN_BRANCH}${URL_ADMIN_BRANCH_MANAGE_DETAIL.replace(':no', record.IDX)}`)}>
              {value}
            </span>
            <Popconfirm
              placement="rightTop"
              icon={false}
              okButtonProps={{style: {display: 'none'}}}
              cancelButtonProps={{style: {display: 'none'}, className: `custom-cancel-className-${index}`}}
              title={
                <Flex justify="space-between" align="center">
                  <RoundTag label="지사" color={'#81DE84'} style={{color: '#008D05'}}/>
                  <div>{record.BRANCH_ID}</div>
                  <CloseOutlined style={{cursor: 'pointer'}} onClick={() => popupClose(index)}/>
                </Flex>
              }
              description={<Descriptions bordered column={1} size="small" labelStyle={{width: '100px', verticalAlign: 'middle'}} contentStyle={{width: '300px', textAlign: 'left', verticalAlign: 'middle'}} items={getBranchPop(record)}/>}
            >
              <Button type="text" icon={<IconExclamation/>} onClick={() => setFocusLow(record?.IDX)}/>
            </Popconfirm>
          </Flex>
        );
      }
    },
    {
      title: '지사아이디',
      align: 'center',
      dataIndex: 'BRANCH_ID',
      width: '8rem'
    },
    {
      title: '지사장명',
      align: 'center',
      dataIndex: 'BRANCH_LEADER_NAME',
      width: '8rem'
    },
    {
      title: '직원수',
      align: 'center',
      dataIndex: 'STAFF_CNT',
      width: '8rem',
      render: (value, record) => {
        return (
          <Flex justify="center" align="center">
            <span className="text-link" onClick={() => fnBranchStaffModal(record.IDX)}>
              {value || 0}명
            </span>
            <Button type="text" icon={<IconExclamation/>} onClick={() => fnStaffjob(record.IDX)} style={{whiteSpace: 'nowrap'}}/>
          </Flex>
        );
      }
    },
    {
      title: '사무실주소',
      align: 'center',
      dataIndex: 'ADDR',
      width: '15rem'
    },
    {
      title: '자택주소',
      align: 'center',
      dataIndex: 'HOME_ADDR',
      width: '15rem'
    },
    {
      title: '배송주소',
      align: 'center',
      dataIndex: 'DELIVERY_ADDR',
      width: '15rem'
    },
    {
      title: '생년월일',
      align: 'center',
      dataIndex: 'BIRTH',
      width: '8rem'
    },
    {
      title: '이메일',
      align: 'center',
      dataIndex: 'EMAIL',
      width: '10rem'
    },
    {
      title: '휴대폰번호',
      align: 'center',
      dataIndex: 'CELL_PHONE',
      width: '12rem'
    },
    {
      title: '전화번호',
      align: 'center',
      dataIndex: 'HOME_PHONE',
      width: '12rem'
    },
    {
      title: '가맹계약일',
      align: 'center',
      dataIndex: 'BRANCH_CONTRACT_DATE',
      width: '12rem',
      render: (value) => {
        const branch_contract_date = dayjs(value).format('YYYY-MM-DD');
        return getFormatDate(value);
      }
    },
    {
      title: '이슈',
      align: 'center',
      // dataIndex: 'col14',
      render: (value, record) => {
        return <OutlinedButton label="상세" color={'var(--color-blue01)'} onClick={() => getBranchIssueModal(record.IDX)}/>;
      }
    },
    {
      title: '수정',
      align: 'center',
      // dataIndex: 'col15',
      render: (value, record) => {
        return <FillButton label="수정" backgroundColor={'var(--color-blue01)'} onClick={() => navigate(`${URL_ADMIN + URL_ADMIN_BRANCH}${URL_ADMIN_BRANCH_MANAGE_EDIT.replace(':no', record.IDX)}`)}/>;
      }
    }
  ];

  const columns2 = [
    {
      title: '정렬순서',
      align: 'center',
      width: '5%',
      dataIndex: 'col1',
      render: (value, record, index) => {
        return index + 1;
      }
    },
    {
      title: '이름',
      align: 'center',
      width: '15%',
      dataIndex: 'STAFF_NAME',
      render: (value, record, index) => {
        return (
          <Input
            style={{width: '100%'}}
            placeholder=""
            maxLength={13}
            value={value}
            onChange={(e) => {
              fnSetData(e.target.value, index, 'STAFF_NAME');
            }}
          />
        );
      }
    },
    {
      title: '직급',
      align: 'center',
      width: '15%',
      dataIndex: 'STAFF_LEVEL',
      render: (value, record, index) => {
        return (
          <Input
            style={{width: '100%'}}
            placeholder=""
            maxLength={13}
            value={value}
            onChange={(e) => {
              fnSetData(e.target.value, index, 'STAFF_LEVEL');
            }}
          />
        );
      }
    },
    {
      title: '입사일자',
      align: 'center',
      width: '10%',
      dataIndex: 'JOIN_COMPANY_DATE',
      render: (value, record, index) => {
        return (
          <BaseDatePicker
            value={value}
            format={'YYYY-MM-DD'}
            style={{width: '100%'}}
            onChange={(date, dateString) => {
              fnSetData(date, index, 'JOIN_COMPANY_DATE');
            }}
          />
        );
      }
    },
    {
      title: (
        <>
          사전점검
          <br/>
          완료여부
        </>
      ),
      align: 'center',
      width: '10%',
      dataIndex: 'BEFORE_CHECK_YN',
      render: (value, record, index) => {
        return (
          <Select
            value={value}
            style={{width: '100%'}}
            options={completionStatusOption}
            onSelect={(e) => {
              fnSetData(e, index, 'BEFORE_CHECK_YN');
            }}
          />
        );
      }
    },
    {
      title: (
        <>
          채용구분
          <br/>
          (단시간/일반)
        </>
      ),
      align: 'center',
      width: '10%',
      dataIndex: 'STAFF_EMPLOY_TYPE',
      render: (value, record, index) => {
        return (
          <Select
            value={value}
            style={{width: '100%'}}
            options={staffEmployTypeOption}
            onSelect={(e) => {
              fnSetData(e, index, 'STAFF_EMPLOY_TYPE');
            }}
          />
        );
      }
    },
    {
      title: '휴대폰번호',
      align: 'center',
      width: '15%',
      dataIndex: 'CELL_PHONE',
      render: (value, record, index) => {
        return (
          <Input
            value={value}
            style={{width: '100%'}}
            placeholder="-없이 입력"
            maxLength={13}
            onChange={(e) => {
              fnSetData(fnCellPhoneFormat(e.target.value), index, 'CELL_PHONE');
            }}
          />
        );
      }
    },
    {
      title: '생년월일',
      align: 'center',
      width: '10%',
      dataIndex: 'BIRTH',
      render: (value, record, index) => {
        return (
          <BaseDatePicker
            value={value}
            format={'YYYY-MM-DD'}
            style={{width: '100%'}}
            onChange={(date, dateString) => {
              fnSetData(date, index, 'BIRTH');
            }}
          />
        );
      }
    },
    {
      title: ' ',
      align: 'center',
      width: '5%',
      dataIndex: 'col9',
      render: (value, record, index) => {
        return <>{record.CREATE_DATE ? <FillButton label="수정" backgroundColor={'var(--color-blue01)'} onClick={(e) => fnUpdateBranchStaff(record)}/> : <FillButton label="등록" backgroundColor={'var(--color-blue01)'} onClick={(e) => fnAddBranchStaff(record, index)}/>}</>;
      }
    },
    {
      title: ' ',
      align: 'center',
      width: '5%',
      dataIndex: 'col10',
      render: (value, record, index) => {
        return <>{record.CREATE_DATE ? <FillButton label="삭제" backgroundColor={'var(--color-blue01)'} onClick={(e) => fnDeleteBranchStaff(record)}/> : null}</>;
      }
    }
  ];

  const columns3 = [
    // {
    //   title: 'no',
    //   align: 'center',
    //   width: '10%',
    //   dataIndex: 'IDX',
    //   render: (value, record, index) => {
    //     return value
    //   }
    // },
    {
      title: '지사아이디',
      align: 'center',
      width: '10%',
      dataIndex: 'BRANCH_ID',
      render: (value, record, index) => {
        return value;
      }
    },
    {
      title: '지사명',
      align: 'center',
      width: '15%',
      dataIndex: 'BRANCH_NAME',
      render: (value, record, index) => {
        return value;
      }
    },
    {
      title: '지사장명',
      align: 'center',
      width: '10%',
      dataIndex: 'BRANCH_LEADER_NAME',
      render: (value, record, index) => {
        return value;
      }
    },
    {
      title: '등록일',
      align: 'center',
      width: '10%',
      dataIndex: 'REGIST_DATE',
      render: (value, record, index) => {
        return value;
      }
    },
    {
      title: '작성자',
      align: 'center',
      width: '10%',
      dataIndex: 'WRITER',
      render: (value, record, index) => {
        return value;
      }
    },
    {
      title: '이슈',
      align: 'center',
      width: '35%',
      dataIndex: 'ISSUE',
      render: (text, record, index) => {
        return (
          <>
            <TextArea
              rows={2}
              placeholder="입력해주세요"
              maxLength={300}
              value={text}
              onChange={(e) => {
                fnSetIssueData(e, record, index, 'ISSUE');
              }}
            />
          </>
        );
      }
    },
    {
      title: ' ',
      align: 'center',
      width: '10%',
      dataIndex: 'col7',
      render: (value, record, index) => {
        return (
          <>
            {record.REGIST_DATE ? (
              <Space>
                <FillButton label="수정" backgroundColor={'var(--color-blue01)'} onClick={() => fnUpdateIssue(record)}/>
                <OutlinedButton label="삭제" color={'red'} onClick={() => fnDeleteIssue(record.IDX)}/>
              </Space>
            ) : (
              <FillButton label="등록" backgroundColor={'var(--color-blue01)'} onClick={() => fnAddIssue(record)}/>
            )}
          </>
        );
      }
    }
  ];

  const columns4 = [
    {
      title: '구분',
      align: 'center',
      onCell: (record, idx) => {
        if (idx === 0) return {rowSpan: 3};
        else if (idx < 3) return {rowSpan: 0};
        else if (idx === 3) return {rowSpan: 7};
        else if (idx < 10) return {rowSpan: 0};
        else if (idx === 10) return {rowSpan: 3};
        else if (idx < 13) return {rowSpan: 0};
        else if (idx === 13) return {rowSpan: 2};
        else if (idx < 15) return {rowSpan: 0};
        else if (idx === 15) return {rowSpan: 1};
        else if (idx === 16) return {rowSpan: 2};
        else if (idx < 18) return {rowSpan: 0};
      },
      render: (value, record, idx) => {
        if (idx < 3) return '계약';
        else if (idx < 10) return '교육원 관리';
        else if (idx < 13) return '홍보';
        else if (idx < 15) return '주문';
        else if (idx < 16) return '상담';
        else return '교육';
      }
    },
    {
      title: '업무',
      align: 'center',
      onCell: (record, idx) => {
        if (idx === 0) return {rowSpan: 2};
        else if (idx < 2) return {rowSpan: 0};
        else if (idx < 4) return {rowSpan: 1};
        else if (idx === 4) return {rowSpan: 2};
        else if (idx < 6) return {rowSpan: 0};
      },
      render: (value, record, idx) => {
        if (idx < 2)
          return (
            <>
              가맹상담 및 창업 설명회,
              <br/>
              학부모 설명회
            </>
          );
        else if (idx === 2) return '가맹계약 체결';
        else if (idx === 3) return '교육원 오픈 프로세스 관리';
        else if (idx < 6) return '교육원 이슈 관리';
        else if (idx === 6) return '교육원 응대';
        else if (idx === 7) return '교육원 입회, 휴회 관리';
        else if (idx === 8) return '교육원 일반 점검';
        else if (idx === 9) return '참관지도교육원 관리';
        else if (idx === 10) return '오프라인 홍보 관리';
        else if (idx === 11) return 'SNS 관리';
        else if (idx === 12) return '네이버 카페 글쓰기 및 블로그';
        else if (idx === 13) return '교재 주문 관리';
        else if (idx === 14) return '교재주문 모니터링, 승인 관리';
        else if (idx === 15) return '학부모 상담프로세스 관리';
        else if (idx === 16) return '교육원 교육 관리';
        else if (idx === 17)
          return (
            <>
              프로그램별 교습법 교육,
              <br/>
              수업점검, 컨설팅
            </>
          );
      }
    },
    {
      title: '업무내용',
      align: 'center',
      render: (value, record, idx) => {
        if (idx === 0)
          return (
            <>
              온라인 가맹상담
              <br/>
              창업설명회 및 학부모설명회 진행
            </>
          );
        else if (idx === 1)
          return (
            <div className="text-red">
              (지사장 필수업무)
              <br/>
              오프라인 가맹 상담
            </div>
          );
        else if (idx === 2)
          return (
            <>
              정보공개서 등 제공, 전자가맹계약 체결,
              <br/>
              가맹금예치금 신청
            </>
          );
        else if (idx === 3) return <>'오픈 전 각종 교육일정 관리, 참관지도 교육진행 관리'</>;
        else if (idx === 4) return <>'휴업, 해지, 이동, 영업부진 해소 등'</>;
        else if (idx === 5)
          return (
            <div className="text-red">
              (지사장 필수업무)
              <br/>
              교육원/학부모 컴플레인 대응
            </div>
          );
        else if (idx === 6) return <>'통상적인 대면/비대면 교육원 관리 업무'</>;
        else if (idx === 7) return <>'각종 입회/휴회 데이터 분석을 통한 교육원의 회원 실적 관리'</>;
        else if (idx === 8) return <>'교육원의 환경 점검, 회원 점검 등 수업 점검 외 업무'</>;
        else if (idx === 9) return <>'참관지도교육원 설정, 해제 및 각종 관리 업무'</>;
        else if (idx === 10) return <>'등/하원 홍보, 전단지 직투 증 교육원 오프라인 홍보 관리'</>;
        else if (idx === 11) return <>'알바천국, 지역맘카페, 인스타그램 등'</>;
        else if (idx === 12)
          return (
            <>
              지사의 네이버 카페/블로그 글쓰기 관리,
              <br/>
              교육원의 온라인 홍보 관리
            </>
          );
        else if (idx === 13) return <>'교육원의 주문, 미주문, 교환, 환불, 회수 관리'</>;
        else if (idx === 14) return <>'교육원의 교재 주문 모니터링, 승인 관리'</>;
        else if (idx === 15)
          return (
            <>
              SPTP를 포함한 회원의 등원기간 내 교육원의
              <br/>
              각종 상담업무 관리
            </>
          );
        else if (idx === 16) return <>'필수교육, 아소비아카데미를 통한 보수교육 관리'</>;
        else if (idx === 17)
          return (
            <>
              아소비 정체성 및 프로그램별 교습법 교육,
              <br/>
              교육원 수업점검 및 컨설팅
              <br/>
              <div className="text-red">※ 사전점검 대상</div>
            </>
          );
      }
    },
    {
      title: (
        <>
          담당자
          <br/>
          (직원명or지사장)
        </>
      ),
      align: 'center',
      // dataIndex: 'col10',
      render: (value, record, idx) => {
        const fnStaffList = async () => {
          const params = {...branch, roll_no: idx + 1};
          await getBranchJobStaffListAPI({params})
            .then((res) => {
              console.log(res.data.data_list);
              const staff_list = res.data.data_list.map((it) => ({value: it.STAFF_IDX, label: it.STAFF_NAME}));
              setOption({...option, staff_list: staff_list});
            })
            .catch((e) => console.log(e));
        };
        return (
          <Space direction="vertical" style={{width: '100%'}}>
            <Space direction="vertical">
              {record.length !== undefined &&
              record.map((it) => (
                <div>
                  {it.STAFF_NAME}
                  <span className="text-red text-click" onClick={() => fnDeleteStaffjob(it)}>
                      [삭제]
                    </span>
                </div>
              ))}
            </Space>
            <Select
              placeholder={'직원을 선택하세요'}
              value={null}
              onClick={fnStaffList}
              options={option?.staff_list}
              style={{width: '100%'}}
              onChange={(e) => {
                fnAddStaffjob(e, record);
              }}
            />
          </Space>
        );
      }
    }
  ];

  const item = [
    {
      key: 1,
      label: '검색조건',
      children: 
        <Space size="small">
          <Select placeholder={'검색 조건 선택'} style={{width: '12rem'}} value={search?.search_state} options={searchTypeOptions(['지사명', '지사아이디', '전화번호', '휴대폰번호'])} onSelect={(e) => setSearch({...search, search_state: e})}/>
          <Input value={search.search_content} style={{width: '16rem'}} onChange={(e) => setSearch({...search, search_content: e.target.value})} onPressEnter={fnGetList}/>
        </Space>,
      span: 1
    },
    {
      key: 2,
      label: <FillButton label="검색하기" width="100px" backgroundColor="var(--color-gray03)" onClick={fnGetList}/>,
      children: <></>,
      span: 1
    }
  ];

  //지사 직원 업무 분장시키기
  const fnStaffjob = async (branch_idx) => {
    fnBranchStaffList(branch_idx);
    fnBranchStaffJobList(branch_idx);
  };

  //지사 업무분장 삭제
  const fnDeleteStaffjob = async (record) => {
    await deleteBranchStaffJobAPI(record.BRANCH_IDX, record.ROLL_NO, record.BRANCH_STAFF_IDX)
      .then((res) => {
        if (res.data.responseCode === 200) {
          alert('삭제되었습니다.');
          fnBranchStaffJobList(branch?.branch_idx);
        }
      })
      .catch((err) => console.log(err));
  };

  const fnAddStaffjob = async (e, record) => {
    let arr;
    if (record.length > 0) arr = record[0];
    else arr = record;
    const param = {
      branch_idx: arr.BRANCH_IDX,
      roll_no: arr.ROLL_NO,
      branch_staff_idx: e
    };
    await postBranchStaffJobAPI(param)
      .then((res) => {
        const {responseCode} = res?.data;
        if (responseCode === 200) {
          alert('등록되었습니다.');
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        fnStaffjob(arr.BRANCH_IDX);
      });
  };

  //직원 업무 분장 모달 open

  const fnBranchStaffJobList = async (branch_idx) => {
    await getBranchStaffJobListAPI(branch_idx).then((res) => {
      if (res.status === 200) {
        const arr = res.data.data_list;
        let job = [];
        for (let i = 1; i <= 18; i++) {
          const filterData = arr?.filter((it) => it.ROLL_NO === i);
          if (filterData?.length > 0) {
            job[i - 1] = filterData;
          } else {
            job.push({
              BRANCH_IDX: branch_idx,
              BRANCH_STAFF_IDX: null,
              CREATE_DATE: null,
              IDX: i,
              ROLL_NO: i,
              STAFF_NAME: null
            });
          }
        }
        setStaffJob(job);
        setModal({
          ...modal,
          isBranchIssue: false,
          isEmpOpen: false,
          staffJobDivision: true,
          isDetail: false
        });
      }
    }).catch(err => console.error(err));
  };

  //지사 직원목록
  const fnBranchStaffList = async (idx) => {
    setBranch({branch_idx: idx});
    await getBranchStaffListAPI(idx).then((res) => {
      let arr = [];
      res.data.data_list?.map((it) => {
        arr.push({label: it.STAFF_NAME, value: it.IDX});
      });
      setOption({...option, staff: arr});
      setEmployee({...employee, current: res.data.data_list});
    }).catch(err => console.error(err));
  };

  //지사 직원목록 추가/변경 모달열기
  const fnBranchStaffModal = (idx) => {
    setBranch({branch_idx: idx});
    fnBranchStaffList(idx);
    setModal({
      ...modal,
      isBranchIssue: false,
      isEmpOpen: true,
      staffJobDivision: false,
      isDetail: false
    });
  };

  //표설정 변경시 테이블 항목 업데이트
  const fnUpdateGridSetting = (v) => {
    setExcelHeaders(fnSetColumn(v, column))
    setColList({
      ...colList,
      gridList: fnSetColumn(v, column)
    });
    setColumns(fnSetColumn(v, column));
    setGridSetting(v);
  };

  return (
    <BaseSection>
      <SearchDesc inline items={item} column={item?.length} labelStyle={{width: '8rem'}}/>
      <BaseContainer>
        <Row>
          <Col span={12}>
            <Space>
              <GridSetting colList={gridSetting} fnUpdateCol={fnUpdateGridSetting}/>
              <ExcelButton
                // label={'엑셀 다운로드(검색)'} //뷰네임 미입력시 기본값
                // isCheckComp={true} //체크박스 컴포넌트 여부 미입력시 X
                headerList={excelHeaders} //필수 헤더리스트 표 설정과 동일한 변수여야함
                gridList={branchList} //필수 실시간 그리드 데이터
                // filterList={[]} //뺄 칼럼 목록 dataIndex 미입력시 dataIndex 키 없는것만 뺌
                renderList={[
                  {
                    dataIndex: 'BRANCH_NAME',
                    render: (item) => item,
                  },
                  {
                    dataIndex: 'STAFF_CNT',
                    render: (item) => `${item}명`,
                  },
                ]} //코드 or 다른이름으로 바꿔서 다운할 목록
                // checkRows={} //isCheckComp true 일시 checkRows 데이터 미입력시 체크작동안함
                // checkKey={} //isCheckComp true 일시 check 한 데이터 dataIndex 키 네임 미입력시 체크작동안함
                // fileName={} //파일네임 미입력시 해당 메뉴이름
              />
            </Space>
          </Col>
          <Col span={12}>
            <Flex justify="flex-end">
              <Space>
                <FillButton label="등록" backgroundColor="var(--color-gray03)" onClick={() => navigate(`${URL_ADMIN + URL_ADMIN_BRANCH}${URL_ADMIN_BRANCH_MANAGE_ADD}`)}/>
              </Space>
            </Flex>
          </Col>
        </Row>
        <Divider className="divider-small"/>
        <Row>
          <Col span={24}>
            <DataGrid rowKey={'key'} columns={excelHeaders} data={branchList} pagination scrollX={1000} onRow={onRow}/>
          </Col>
        </Row>
      </BaseContainer>

      {/* =============모달영역===================== */}
      <SimpleModal open={modal.isEmpOpen} title="지사직원" width="80%" onClose={() => setModal({...modal, isBranchIssue: false, isEmpOpen: false, staffJobDivision: false, isDetail: false})}>
        <Row>
          <Col span={24}>
            <Flex justify="end">
              <FillButton label="직원추가" backgroundColor={'var(--color-blue01)'} onClick={() => setEmployee({...employee, current: [...employee.current, {}]})}/>
            </Flex>
            <Divider className="divider-small"/>

            <DataGrid
              bordered
              // rowKey={(record) => (`${record.key}${record.name}`)}
              rowKey={'key'}
              columns={columns2}
              data={employee.current}
              pagination={false}
              onRow={onRow}
            />
          </Col>
        </Row>
      </SimpleModal>

      <SimpleModal open={modal.isBranchIssue} title="지사 이슈" width="80%" onClose={() => setModal({...modal, isBranchIssue: false, isEmpOpen: false, staffJobDivision: false, isDetail: false})}>
        <Row>
          <Col span={24}>
            <Flex justify="end">
              <FillButton label="이슈추가" backgroundColor={'var(--color-blue01)'} onClick={postBranchIssue}/>
            </Flex>
            <Divider className="divider-small"/>

            <DataGrid bordered columns={columns3} data={issue} pagination={false} onRow={onRow}/>
          </Col>
        </Row>
      </SimpleModal>

      <SimpleModal open={modal.staffJobDivision} title="지사 업무분장" width="90%" onClose={() => setModal({...modal, isBranchIssue: false, isEmpOpen: false, staffJobDivision: false, isDetail: false})}>
        <Row>
          <Col span={24}>
            <DataGrid bordered columns={columns4} data={staffJob} pagination={false} onRow={onRow}/>
          </Col>
        </Row>
      </SimpleModal>

      <SimpleModal
        open={modal.isDetail}
        onClose={() => setModal({...modal, isBranchIssue: false, isEmpOpen: false, staffJobDivision: false, isDetail: false})}
        title="지사 정보수정"
        width="1200px"
        height="70vh"
        footer={[
          <Flex justify="center">
            <FillButton key={'close'} label="닫기" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={() => setModal({...modal, isBranchIssue: false, isEmpOpen: false, staffJobDivision: false, isDetail: false})}/>
          </Flex>
        ]}
      >
        <SchoolManageEdit/>
      </SimpleModal>
      <AlertModal open={alertModal?.open} onCancel={fnCloseAlertModal}>
        {alertModal?.message}
      </AlertModal>
    </BaseSection>
  );
}

export default BranchManage;
